import React, { Component } from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { SplitButton } from 'primereact/splitbutton';
import AssessmentUtil from '../../utils/AssessmentUtil';
import { Loading } from '../Loading';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
  remind: {
    id: 'assessment.remind.send',
    defaultMessage: 'Send Reminder',
  },
  invite: {
    id: 'assessment.invite.send',
    defaultMessage: 'Sending...',
  },
  reset: {
    id: 'assessment.resetStatus',
    defaultMessage: 'Reset status',
  },
  invitePreview: {
    id: 'assessment.invite.preview',
    defaultMessage: 'Preview Invite',
  },
  remindPreview: {
    id: 'assessment.remind.preview',
    defaultMessage: 'Preview Remind',
  },
});

class SendNotificationButton extends Component {
  constructor(props) {
    super(props);

    this.sendEmail = this.sendEmail.bind(this);
    this.handlePreviewInviteEmail = this.handlePreviewInviteEmail.bind(this);
    this.handlePreviewRemindEmail = this.handlePreviewRemindEmail.bind(this);

    const { intl } = props;
    const { formatMessage } = intl;
    this.state = {
      items: [
        {
          label: formatMessage(messages.invitePreview),
          command: () => {
            this.handlePreviewInviteEmail();
          },
        },
        {
          label: formatMessage(messages.remindPreview),
          command: () => {
            this.handlePreviewRemindEmail();
          },
        },
      ],
    };
  }

  sendEmail() {
    const { actionMethod } = this.props;
    actionMethod();
  }

  handlePreviewInviteEmail() {
    const { assessment } = this.props;
    window.open(assessment.previewInviteUrl, '_blank');
  }

  handlePreviewRemindEmail() {
    const { assessment } = this.props;
    window.open(assessment.previewReminderUrl, '_blank');
  }

  render() {
    const { assessment, intl, isDisabled } = this.props;
    const { formatMessage } = intl;

    if (!assessment) {
      return <Loading />;
    }

    const isInvitable = AssessmentUtil.isInvitable(assessment);
    const isRemindable = AssessmentUtil.isRemindable(assessment);
    const isDeclineStatus = AssessmentUtil.isResetAssessmentDeclineStatus(assessment);
    let labelMessage = '';
    if (isInvitable) {
      labelMessage = formatMessage(messages.invite);
    } else if (isRemindable) {
      labelMessage = formatMessage(messages.remind);
    } else if (isDeclineStatus) {
      labelMessage = formatMessage(messages.reset);
    }
    const { items } = this.state;

    return (
      <div className="vertList-item vertList-item--block">
        <p className="vertList-header">
          {isInvitable && <FormattedMessage id="assessment.invite" defaultMessage="Invite Candidate" />}
          {isRemindable && <FormattedMessage id="assessment.remind" defaultMessage="Send Reminders" />}
        </p>

        {/* <p>{previewLink}</p> */}

        <div className="vertList-actions">
          <SplitButton
            label={labelMessage}
            icon={isInvitable || isRemindable ? 'pi pi-bell' : ''}
            onClick={this.sendEmail}
            model={items}
            disabled={isDisabled}
          />
        </div>
      </div>
    );
  }
}

SendNotificationButton.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  actionMethod: PropTypes.func.isRequired,
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(SendNotificationButton);
